export default __webpack_public_path__ + "static/FilsonSoft-BoldItalic-4aecc3fd24f617f223f19df090e00888.ttf";